import { render, staticRenderFns } from "./FigmaIcon.vue?vue&type=template&id=7b7eb716&scoped=true"
import script from "./FigmaIcon.vue?vue&type=script&lang=ts"
export * from "./FigmaIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7eb716",
  null
  
)

export default component.exports